import { Markup } from 'interweave'
import Attachment from '../../UI/Attachment/Attachment'

export const columnsQuestions = [
    {
        field: 'question',
        header: 'modals.news_execution.approval.stores_detail.table.header.question',
        isMain: true,
        template: (rowData: any) => {
            return (
                <div>
                    <Markup content={rowData.question} />
                </div>
            )
        },
    },
    {
        field: 'completion',
        header: 'modals.news_execution.approval.stores_detail.table.header.completion',
        isMain: true,
    },
    {
        field: 'answer',
        header: 'modals.news_execution.approval.stores_detail.table.header.answer',
    },
    {
        field: 'question_type',
        header: 'modals.news_execution.approval.stores_detail.table.header.question_type',
    },
    {
        field: 'attachments',
        header: 'modals.news_execution.approval.stores_detail.table.header.attachments',
        template: (rowData: any) => {
            return rowData?.attachments?.length ? (
                <div>
                    {rowData.attachments.map((a: any, i: number) => {
                        return (
                            <div key={i} style={{ marginBottom: 'var(--spacing-3)' }}>
                                <Attachment
                                    fileUrl={a.url}
                                    fileName={a.name}
                                    fileExtension={a.ext}
                                    showDownloadIcon={true}
                                    // hideEyeIcon={true}
                                />
                            </div>
                        )
                    })}
                </div>
            ) : (
                <>/</>
            )
        },
    },
]
